import type { RetryOptions } from '../../types';

export const resolveRetryDelay = ({
  retryDelay,
  numberOfFailedAttempts,
  response,
}: {
  retryDelay: RetryOptions['retryDelay'];
  numberOfFailedAttempts: number;
  response: Response;
}): number => {
  if (typeof retryDelay === 'function') {
    return retryDelay({ numberOfFailedAttempts, response });
  }

  return retryDelay;
};
